import Config from "../_config/config";
import myAxios from "./axiositeachWrapper";

/**
 * Document templates (invoice / receipt / SOA). Same postbox_template_master
 * table as email templates, but persisted to the `Mustache` column that
 * nodefork's invoice renderer reads. Mirrors CampaignService's template methods
 * against the /v1/document-templates endpoints.
 */
const BASE = `${Config.nodeSiteUrl}v1/document-templates`;

export interface DocumentTemplateBody {
  Name: string;
  Mustache?: string | null;
  DesignJson?: string | null;
}

class DocumentTemplateService {
  list() {
    return myAxios.get<any>(BASE);
  }

  get(id: number) {
    return myAxios.get<any>(`${BASE}/${id}`);
  }

  create(body: DocumentTemplateBody) {
    return myAxios.post<any>(BASE, body);
  }

  update(id: number, body: DocumentTemplateBody) {
    return myAxios.put<any>(`${BASE}/${id}`, body);
  }

  remove(id: number) {
    return myAxios.delete<any>(`${BASE}/${id}`);
  }

  duplicate(id: number) {
    return myAxios.post<any>(`${BASE}/${id}/duplicate`);
  }

  getStarters() {
    return myAxios.get<any>(`${BASE}/starters`);
  }
}

export default new DocumentTemplateService();
